































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Input,Button,Pagination } from "ant-design-vue";
import CList from "@/components/CList/index.vue";

@Component({
  name: "Notice",
  components: {
    CList,
    AInputSearch: Input.Search,
    AButton: Button,
    APagination: Pagination
  }
})
export default class Notice extends Base {
  private pageNum = 1;
  private total = 0;
  private pageSize = 10;
  private dataSource: any[] = [];
  private searchValue = "";

  private created() {
    this._created();
    this.getList(null);
  }

  private async getList(searchValue: string | null) {
    const res = await this.$api.NoticeList({
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      searchValue:searchValue
    });
    if (res && res.code === 200) {
      this.total = res.total;
      this.dataSource = res.rows;
    }
  }

  private goSearch() {
    // undo
    debugger;
    this.getList(this.searchValue);    
  }

  private onChange() {
    this.getList(null);
  }
  private async initiSearchVal() {
    this.searchValue = "";
    this.getList(null);
  }

  private onShowSizeChange() {
    this.pageNum = 1;
    this.getList(null);
  }
}
